<template>
  <div ref="container" v-resize="checkWidth" class="vz-order-view-total-linked-orders" :class="componentClass">
    <div class="vz-personal-order-total-card-item">
      <span class="text-h1">Связанные заказы</span>
    </div>

    <div
      v-for="order in orders"
      :key="order.orderNumber"
      class="vz-order-view-total-linked-order vz-personal-order-total-card-item"
      @click="onLinkedOrderClick(order.id)"
    >
      <div class="vz-order-view-total-linked-order--title">
        <span>Заказ № {{ order.orderNumber }}</span>
        <div>Плательщик: {{ order.payer }}</div>
      </div>
      <div class="vz-order-view-total-linked-order--price">
        <div>
          <div class="vz-order-view-total-linked-order--price-cost">
            <vz-icon
              no-masked-icon
              size="16"
              class="mr-5"
              :url="flag"
            />
            <div>{{ order.price }} {{ currencyText }}</div>
          </div>
          <div class="vz-order-view-total-linked-order--price-title">
            Сумма заказа
          </div>
        </div>
        <div v-if="order.debt">
          <div class="vz-order-view-total-linked-order--price-cost">
            <vz-icon
              no-masked-icon
              size="16"
              class="mr-5"
              :url="flag"
            />
            <div class="color-primary">
              {{ order.debt }} {{ currencyText }}
            </div>
          </div>
          <div class="vz-order-view-total-linked-order--price-title">
            К оплате
          </div>
        </div>
        <div v-else-if="order.needPaymentStatus !== false" class="color-success text-caption">
          <vz-icon
            name="check"
            variant="success"
            size="14"
          />
          <span>Оплачен</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useOrderStore } from '~/stores/order';
import { OrderView, VzClass } from '~/types/types';

type LinkedOrdersItem = {
  orderNumber: string
  debt: number
  id: string
  payer: string
  price: number
  needPaymentStatus?: boolean
}

  const router = useRouter()
  const width = ref(400)
  const container = ref()
  const store = useOrderStore()
  const currencyText = computed((): string => {
    return store.orderPriceCurrency.currency
  })

  const flag = computed((): string => {
    return store.orderPriceCurrency.flag
  })

  const orders = computed((): LinkedOrdersItem[] => {
    return Object.entries(store.orderForm.linkedOrders || {}).reverse().reduce((result: LinkedOrdersItem[], item) => {
      result.push({ orderNumber: item[0], ...item[1] })
      return result
    }, [])
  })

  const componentClass = computed((): VzClass => {
    return width.value > 350 ? 'vz-order-view-total-linked-orders-wide' : ''
  })

  onMounted((): void => {
    checkWidth()
  })

  function onLinkedOrderClick(guid: string): void {
    if (useRoute().name?.toString().includes('personal')) {
      router.push({
        path: `/personal/order/${guid}/`
      })
    } else {
      router.push({
        path: `/order/administer/${guid}/`
      })
    }
  }

  function checkWidth(): void {
    if (container.value) {
      width.value = container.value.getBoundingClientRect().width
    }
  }

</script>

<style lang="scss" scoped>
.vz-order-view-total-linked-orders {
  .vz-order-view-total-linked-order {
    padding-top: 20px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    &:not(:last-child) {
      border-bottom: dashed 1px $border-gray;
      padding-bottom: 20px;
    }

    &--title {
      margin: 0 0 10px 20px;
      > span {
        font-size: 14px;
        display: list-item;
        margin-bottom: 8px;
      }
      > div {
        font-size: 12px;
      }
    }

    &--price {
      margin-left: 20px;
      flex-direction: row !important;
      &-cost {
        font-size: 14px;
        display: flex;
        > div {
          white-space: nowrap;
        }
      }

      &-title {
        color: $font-light;
        font-size: 12px;
        white-space: nowrap;
      }
      > div:nth-child(2) {
        margin-left: 20px;
      }
    }

    > div {
      display: flex;
      flex-direction: column;
      line-height: 20px;
    }

    &:hover {
      background-color: $component-background;
    }
  }

  &-wide {
    .vz-order-view-total-linked-order {
      flex-direction: row;
      align-items: center;

      &--price {
        flex-direction: column !important;
        > div:last-child {
          margin-left: 0;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
